/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import {noop} from '@benchling/js-utils';
import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import Button, {ButtonLink, ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import PaddedBorderedCell from 'ui-library/internal/PaddedBorderedCell';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import {capitalize} from 'util/NameUtil';

interface DropdownMenuProps {
  options?: Array<{
    text: string | number;
    onSelect: (...args: Array<any>) => any;
  }>;
  children?: JSX.Element;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function DropdownMenu({options, children}: DropdownMenuProps) {
  /* TODO: maybe Dropdown should accept undefined children */
  return (
    <Dropdown
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.SMALL}>
          {options!.map((opt, i) => (
            <Option key={i} onSelect={opt.onSelect}>
              {opt.text}
            </Option>
          ))}
        </Menu>
      }
    >
      {children!}
    </Dropdown>
  );
}

// eslint-disable-next-line no-restricted-syntax
const BUTTON_SIZES = _.values(ButtonSize);
// eslint-disable-next-line no-restricted-syntax
const BUTTON_STYLES = _.values(ButtonStyle);

class ButtonGuidelines extends React.Component {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _renderButtonWithStyle = (style: any, i: any, isIcon?: any) => (
    <Button
      buttonStyle={style}
      className={classNames({'u-mini-spacing-left': i > 0})}
      icon={isIcon ? 'search' : undefined}
      key={`button-${_.uniqueId()}`}
      size={ButtonSize.MEDIUM}
      text={!isIcon ? style.charAt(0).toUpperCase() + style.substr(1) : null}
    />
  );

  render = (): JSX.Element => {
    const buttonSizes = _.clone(BUTTON_SIZES).reverse();
    // eslint-disable-next-line no-restricted-syntax
    const fakeDropdownOptions = _.times(5, (num) => ({
      onSelect: noop,
      text: num,
    }));

    return (
      <div className="u-padding">
        <h1>Buttons</h1>
        <a href="https://zpl.io/ZouraR">https://zpl.io/ZouraR</a>
        <div className="u-large-spacing-top">
          <div className="u-small-spacing-bottom">Buttons can take the following sizes and forms:</div>
          <table>
            <thead>
              <tr>
                <PaddedBorderedCell>Buttons</PaddedBorderedCell>
                <PaddedBorderedCell>Large</PaddedBorderedCell>
                <PaddedBorderedCell>Medium</PaddedBorderedCell>
                <PaddedBorderedCell>Small</PaddedBorderedCell>
                <PaddedBorderedCell>Mini</PaddedBorderedCell>
              </tr>
            </thead>
            <tbody>
              <tr>
                <PaddedBorderedCell>Text</PaddedBorderedCell>
                {(() =>
                  buttonSizes.map((size, i) => (
                    <PaddedBorderedCell key={`textButton-${i}`}>
                      <Button buttonStyle={ButtonStyle.PRIMARY} size={size} text="Button" />
                    </PaddedBorderedCell>
                  )))()}
              </tr>
              <tr>
                <PaddedBorderedCell>Text + Icon</PaddedBorderedCell>
                {(() =>
                  buttonSizes.map((size, i) => (
                    <PaddedBorderedCell key={`iconTextButton-${i}`}>
                      <Button buttonStyle={ButtonStyle.PRIMARY} icon="star" size={size} text="Button" />
                    </PaddedBorderedCell>
                  )))()}
              </tr>
              <tr>
                <PaddedBorderedCell>Text Dropdown</PaddedBorderedCell>
                {(() =>
                  buttonSizes.map((size, i) => (
                    <PaddedBorderedCell key={`textDropdown-${i}`}>
                      <DropdownMenu options={fakeDropdownOptions}>
                        <Button
                          buttonStyle={ButtonStyle.PRIMARY}
                          isDropdown={true}
                          size={size}
                          text="Button"
                        />
                      </DropdownMenu>
                    </PaddedBorderedCell>
                  )))()}
              </tr>
              <tr>
                <PaddedBorderedCell>Icon</PaddedBorderedCell>
                {(() =>
                  buttonSizes.map((size, i) => (
                    <PaddedBorderedCell key={`iconButton-${i}`}>
                      <Button buttonStyle={ButtonStyle.PRIMARY} icon="invite" size={size} />
                    </PaddedBorderedCell>
                  )))()}
              </tr>
              <tr>
                <PaddedBorderedCell>Circle Icon (can be dropdown)</PaddedBorderedCell>
                {(() =>
                  buttonSizes.map((size, i) => (
                    <PaddedBorderedCell key={`circleIcon-${i}`}>
                      <DropdownMenu options={fakeDropdownOptions}>
                        <Button
                          buttonStyle={ButtonStyle.CIRCLE_ICON}
                          icon="helix"
                          isDropdown={true}
                          size={size}
                        />
                      </DropdownMenu>
                    </PaddedBorderedCell>
                  )))()}
              </tr>
              <tr>
                <PaddedBorderedCell>Icon Dropdown</PaddedBorderedCell>
                {(() =>
                  buttonSizes.map((size, i) => (
                    <PaddedBorderedCell key={`iconDropdown-${i}`}>
                      <DropdownMenu options={fakeDropdownOptions}>
                        <Button
                          buttonStyle={ButtonStyle.PRIMARY}
                          icon="split-workspace"
                          isDropdown={true}
                          size={size}
                        />
                      </DropdownMenu>
                    </PaddedBorderedCell>
                  )))()}
              </tr>
            </tbody>
          </table>
        </div>
        <div className="u-small-spacing-top">
          Full width button. <strong>Please use sparingly.</strong>
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            icon={ModelTypeConstants.REGISTRY}
            fullWidth={true}
            size={ButtonSize.MEDIUM}
            text="Full Width Button"
          />
        </div>
        <div className="u-large-spacing-top">
          <div className="u-small-spacing-bottom">
            The following button styles can be used for text buttons:
          </div>
          <table>
            <thead>
              <tr>
                <PaddedBorderedCell>Style</PaddedBorderedCell>
                <PaddedBorderedCell>Variations</PaddedBorderedCell>
              </tr>
            </thead>
            <tbody>
              <tr>
                <PaddedBorderedCell>Primary</PaddedBorderedCell>
                <PaddedBorderedCell>
                  {(() => [ButtonStyle.PRIMARY].map((style, i) => this._renderButtonWithStyle(style, i)))()}
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>Secondary</PaddedBorderedCell>
                <PaddedBorderedCell>
                  {(() =>
                    [ButtonStyle.SECONDARY, ButtonStyle.SECONDARY_WHITE, ButtonStyle.SECONDARY_BLACK].map(
                      (style, i) => this._renderButtonWithStyle(style, i)
                    ))()}
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>Tertiary</PaddedBorderedCell>
                <PaddedBorderedCell>
                  {(() =>
                    [
                      ButtonStyle.TERTIARY_BLUE,
                      ButtonStyle.TERTIARY_GRAY,
                      ButtonStyle.TERTIARY_WHITE,
                      ButtonStyle.TERTIARY_BLUE_POWDER,
                    ].map((style, i) => this._renderButtonWithStyle(style, i)))()}
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>a11y</PaddedBorderedCell>
                <PaddedBorderedCell>
                  <Button buttonStyle={ButtonStyle.LINK} key={`button-${_.uniqueId()}`} text="Anchor" />
                  <Button
                    buttonStyle={ButtonStyle.UNBUTTON}
                    className="u-mini-spacing-left"
                    key={`button-${_.uniqueId()}`}
                  >
                    <div style={{border: '1px solid blue', padding: '0 4px 0 4px'}}>Custom component</div>
                  </Button>
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>Other</PaddedBorderedCell>
                <PaddedBorderedCell>
                  {(() =>
                    [ButtonStyle.NEGATIVE, ButtonStyle.WARNING].map((style, i) =>
                      this._renderButtonWithStyle(style, i)
                    ))()}
                </PaddedBorderedCell>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="u-large-spacing-top">
          <div className="u-small-spacing-bottom">
            The following button styles can be used for icon buttons:
          </div>
          <table>
            <thead>
              <tr>
                <PaddedBorderedCell>Style</PaddedBorderedCell>
                <PaddedBorderedCell>Variations</PaddedBorderedCell>
              </tr>
            </thead>
            <tbody>
              <tr>
                <PaddedBorderedCell>Primary</PaddedBorderedCell>
                <PaddedBorderedCell>
                  {(() =>
                    [ButtonStyle.PRIMARY].map((style, i) => this._renderButtonWithStyle(style, i, true)))()}
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>Secondary</PaddedBorderedCell>
                <PaddedBorderedCell>
                  {(() =>
                    [ButtonStyle.SECONDARY, ButtonStyle.SECONDARY_WHITE].map((style, i) =>
                      this._renderButtonWithStyle(style, i, true)
                    ))()}
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>Tertiary</PaddedBorderedCell>
                <PaddedBorderedCell>
                  {(() =>
                    [
                      ButtonStyle.TERTIARY_BLUE,
                      ButtonStyle.TERTIARY_WHITE,
                      ButtonStyle.TERTIARY_GRAY,
                      ButtonStyle.TERTIARY_BLUE_POWDER,
                    ].map((style, i) => this._renderButtonWithStyle(style, i, true)))()}
                </PaddedBorderedCell>
              </tr>
              <tr>
                <PaddedBorderedCell>Other</PaddedBorderedCell>
                <PaddedBorderedCell>
                  {(() =>
                    [ButtonStyle.NEGATIVE, ButtonStyle.WARNING, ButtonStyle.CIRCLE_ICON].map((style, i) =>
                      this._renderButtonWithStyle(style, i, true)
                    ))()}
                </PaddedBorderedCell>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="u-large-spacing-top">
          <div className="u-small-spacing-bottom">
            Buttons can act as links when using the ButtonLink component:
          </div>
          <ButtonLink
            buttonStyle={ButtonStyle.PRIMARY}
            size={ButtonSize.SMALL}
            text="Take me to Benchling!"
            href="https://benchling.com/"
            target="_blank"
            onClick={() => {
              console.log('meow!');
            }}
          />
          <ButtonLink
            buttonStyle={ButtonStyle.PRIMARY}
            className="u-small-spacing-left"
            size={ButtonSize.SMALL}
            text="I am a disabled link button"
            href="https://benchling.com/"
            disabled={true}
          />
        </div>
        <div className="u-large-spacing-top">
          <div className="u-small-spacing-bottom">Buttons should have 6px between them:</div>
          <table>
            <thead>
              <tr>
                <PaddedBorderedCell>Style</PaddedBorderedCell>
                <PaddedBorderedCell>Variations</PaddedBorderedCell>
              </tr>
            </thead>
            <tbody>
              {(() =>
                BUTTON_SIZES.map((size, i) => (
                  <tr key={`buttonSpacing-${i}`}>
                    <PaddedBorderedCell>{capitalize(size)}</PaddedBorderedCell>
                    <PaddedBorderedCell>
                      {/* eslint-disable-next-line no-restricted-syntax */}
                      {_.times(2, (j) => (
                        <Button
                          buttonStyle={ButtonStyle.PRIMARY}
                          className={classNames({'u-mini-spacing-left': j === 1})}
                          key={`button-${_.uniqueId()}`}
                          size={size}
                          text="Button"
                        />
                      ))}
                    </PaddedBorderedCell>
                  </tr>
                )))()}
            </tbody>
          </table>
        </div>
        <div className="u-large-spacing-top">
          <div className="u-small-spacing-bottom">Button groups also exist:</div>
          <table>
            <thead>
              <tr>
                <PaddedBorderedCell>Size</PaddedBorderedCell>
                <PaddedBorderedCell>Styles</PaddedBorderedCell>
                <PaddedBorderedCell>More Styles</PaddedBorderedCell>
              </tr>
            </thead>
            <tbody>
              {(() => {
                // eslint-disable-next-line no-restricted-syntax
                const buttonGroupStyles = _.without(
                  BUTTON_STYLES,
                  ButtonStyle.SECONDARY_WHITE,
                  ButtonStyle.TERTIARY_WHITE,
                  ButtonStyle.TERTIARY_BLUE_POWDER,
                  ButtonStyle.NEGATIVE,
                  ButtonStyle.WARNING,
                  ButtonStyle.CIRCLE_ICON
                );
                // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                const getStyle = (idx: any) => buttonGroupStyles[idx % buttonGroupStyles.length];
                return BUTTON_SIZES.map((size, i) => (
                  <tr key={`buttonGroup-${i}`}>
                    <PaddedBorderedCell>{capitalize(size)}</PaddedBorderedCell>
                    {/* eslint-disable-next-line no-restricted-syntax */}
                    {_.times(2, (j) => (
                      <PaddedBorderedCell key={`buttonGroup-button-${i * 2 + j}`}>
                        <div className="buttonGroup">
                          <Button buttonStyle={getStyle(i * 2 + j)} size={size} text="Button" />
                          <Button
                            buttonStyle={getStyle(i * 2 + j)}
                            icon="history"
                            size={size}
                            text="Button"
                          />
                          <DropdownMenu options={fakeDropdownOptions}>
                            <Button
                              buttonStyle={getStyle(i * 2 + j)}
                              icon="tutorial"
                              isDropdown={true}
                              size={size}
                            />
                          </DropdownMenu>
                        </div>
                      </PaddedBorderedCell>
                    ))}
                  </tr>
                ));
              })()}
            </tbody>
          </table>
        </div>
        <div className="u-large-spacing-top">
          <div className="u-small-spacing-bottom">You can even make button toolbars!</div>
          <table>
            <thead>
              <tr>
                <PaddedBorderedCell>Size</PaddedBorderedCell>
                <PaddedBorderedCell>Styles</PaddedBorderedCell>
              </tr>
            </thead>
            <tbody>
              {(() => {
                // eslint-disable-next-line no-restricted-syntax
                const buttonGroupStyles = _.without(
                  BUTTON_STYLES,
                  ButtonStyle.SECONDARY_WHITE,
                  ButtonStyle.TERTIARY_WHITE,
                  ButtonStyle.NEGATIVE,
                  ButtonStyle.WARNING,
                  ButtonStyle.CIRCLE_ICON
                );
                // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                const getStyle = (idx: any) => buttonGroupStyles[idx % buttonGroupStyles.length];
                return BUTTON_SIZES.map((size, i) => (
                  <tr key={`buttonToolbar-${i}`}>
                    <PaddedBorderedCell>{capitalize(size)}</PaddedBorderedCell>
                    <PaddedBorderedCell>
                      <div className="buttonToolbar">
                        {/* eslint-disable-next-line no-restricted-syntax */}
                        {_.times(3, (j) => (
                          <div className="buttonGroup" key={`buttonGroup-${i * 3 + j}`}>
                            <Button
                              buttonStyle={getStyle(i)}
                              icon={ModelTypeConstants.REGISTRY}
                              size={size}
                            />
                            <Button buttonStyle={getStyle(i)} icon="history" size={size} />
                            <Button buttonStyle={getStyle(i)} icon="tutorial" size={size} />
                          </div>
                        ))}
                      </div>
                    </PaddedBorderedCell>
                  </tr>
                ));
              })()}
            </tbody>
          </table>
        </div>
        <div className="u-large-spacing-top">
          <div className="u-small-spacing-bottom">Buttons can also be active or disabled:</div>
          <table>
            <thead>
              <tr>
                <PaddedBorderedCell>Style</PaddedBorderedCell>
                <PaddedBorderedCell>Default</PaddedBorderedCell>
                <PaddedBorderedCell>Active</PaddedBorderedCell>
                <PaddedBorderedCell>Disabled</PaddedBorderedCell>
              </tr>
            </thead>
            <tbody>
              {(() =>
                BUTTON_STYLES.map((style, i) => (
                  <tr key={`buttonStyle-${i}`}>
                    <PaddedBorderedCell>{style.charAt(0).toUpperCase() + style.substr(1)}</PaddedBorderedCell>
                    {/* eslint-disable-next-line no-restricted-syntax */}
                    {_.times(3, (j) => (
                      <PaddedBorderedCell key={`buttonState-${i * 3 + j}`}>
                        <Button
                          buttonStyle={style}
                          className={classNames({'is-active': j === 1})}
                          icon="tutorial"
                          size={ButtonSize.MEDIUM}
                          disabled={j === 2}
                        />
                      </PaddedBorderedCell>
                    ))}
                  </tr>
                )))()}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
}

export default ButtonGuidelines;
